module.exports = __webpack_public_path__ + "img/orange_004.26b71adc.png";